import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import {
  ClientServiceCreateResponseJson,
  ClientServiceListRequestJson,
} from '@vmspdb/definitions';

export const listClients = createAction(
  '[Client/API] List Clients',
  props<{ params: Partial<ClientServiceListRequestJson> }>(),
);

export const listClientsFailure = createAction(
  '[Client/API] List Clients Failure',
  props<{ error: any }>(),
);

export const loadClients = createAction(
  '[Client/API] Load Clients',
  props<{ clients: ClientServiceCreateResponseJson[] }>(),
);

export const loadSingleClient = createAction(
  '[Client/API] Load Single Client',
  props<{ uuid: string }>(),
);

export const loadSingleClientFailure = createAction(
  '[Client/API] Load Single Client Failure',
  props<{ error: any }>(),
);

export const addClient = createAction(
  '[Client/API] Add Client',
  props<{ client: ClientServiceCreateResponseJson }>(),
);

export const upsertClient = createAction(
  '[Client/API] Upsert Client',
  props<{ client: ClientServiceCreateResponseJson }>(),
);

export const addClients = createAction(
  '[Client/API] Add Clients',
  props<{ clients: ClientServiceCreateResponseJson[] }>(),
);

export const upsertClients = createAction(
  '[Client/API] Upsert Clients',
  props<{ clients: ClientServiceCreateResponseJson[] }>(),
);

export const updateClient = createAction(
  '[Client/API] Update Client',
  props<{ client: Update<ClientServiceCreateResponseJson> }>(),
);

export const updateClients = createAction(
  '[Client/API] Update Clients',
  props<{
    clients: Update<ClientServiceCreateResponseJson>[];
  }>(),
);

export const deleteClient = createAction(
  '[Client/API] Delete Client',
  props<{ id: string }>(),
);

export const deleteClients = createAction(
  '[Client/API] Delete Clients',
  props<{ ids: string[] }>(),
);

export const clearClients = createAction('[Client/API] Clear Clients');
